var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#143232",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.066 108h-4.132C117.347 108 32 256 32 256s84.534 148 221.934 148h4.132C395.466 404 480 256 480 256s-85.347-148-221.934-148zm74.3 224.369C311.969 352.767 284.847 364 255.996 364c-28.856 0-55.98-11.235-76.375-31.636C159.23 311.97 148 284.85 148 256.001c0-28.85 11.23-55.97 31.62-76.365C200.015 159.235 227.138 148 255.995 148c28.85 0 55.973 11.233 76.372 31.631S364 227.151 364 256.001c0 28.849-11.234 55.97-31.633 76.368z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.995 188C293.557 188 324 218.443 324 256s-30.443 68-68.005 68C218.422 324 188 293.557 188 256s30.422-68 67.995-68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e20aa2562cfd140e7992bd5f4e7457e0.svg";
export { ForwardRef as ReactComponent };